import React from 'react';
import { styled, Caption } from '@teko/ds-desktop';

const Wrapper = styled.div `
  color: #848788;
  font-size: 0.875rem;
  display: flex;
  flex-wrap: wrap;
`;
const Variant = styled.div `
  display: flex;
`;
const Variants = ({ variants = [], }) => (React.createElement(Wrapper, null, variants.map((variant, index) => (React.createElement(Variant, { key: index },
    React.createElement(Caption, { level: 1, color: "textSecondary" },
        variant.name,
        ": ",
        variant.value),
    index !== variants.length - 1 && (React.createElement(Caption, { margin: ['s0', 's8'], color: "#E4E5F0" }, "|")))))));

export { Variants };
